import { ApolloError, useQuery } from "@apollo/client";
import { GET_VARIABLE } from "src/operations/queries/getVariable";

export type ConfigurationItem = {
    sysId: string;
    name: string;
};

export function useReference(
    companySysId: string | undefined,
    refName: string
): [ConfigurationItem[], boolean, ApolloError | undefined] {
    const { data, loading, error } = useQuery<{ configurationItems: ConfigurationItem[] }>(GET_VARIABLE, {
        variables: { className: refName, query: { company: companySysId } },
        errorPolicy: "all",
        skip: !refName,
        notifyOnNetworkStatusChange: true
    });

    return [data ? data.configurationItems : [], loading, error];
}
